<div class="chart-date-interval-selector">
  <div
    [ngClass]="{
      'chart-date-interval-selector__selected-box--day': buttonState.activeButton === 'DAY',
      'chart-date-interval-selector__selected-box--week': buttonState.activeButton === 'WEEK',
      'chart-date-interval-selector__selected-box--month': buttonState.activeButton === 'MONTH'
    }"
  ></div>

  <button
    [ngClass]="{
      'chart-date-interval-selector__item--active': buttonState.activeButton === 'DAY',
      disabled: buttonState.disabledButtons.DAY
    }"
    class="chart-date-interval-selector__item"
    (click)="!buttonState.disabledButtons.DAY ? activeButtonChange('DAY') : null"
    [matTooltipDisabled]="!buttonState.disabledButtons.DAY"
    [matTooltip]="'CHART_DATE_INTERVAL_SELECTOR.TOOLTIP.DAY' | translate"
  >
    <span>{{ 'CHART_DATE_INTERVAL_SELECTOR.DAY' | translate }}</span>
  </button>

  <button
    [ngClass]="{
      'chart-date-interval-selector__item--active': buttonState.activeButton === 'WEEK',
      disabled: buttonState.disabledButtons.WEEK
    }"
    class="chart-date-interval-selector__item"
    (click)="!buttonState.disabledButtons.WEEK ? activeButtonChange('WEEK') : null"
    [matTooltipDisabled]="!buttonState.disabledButtons.WEEK"
    [matTooltip]="'CHART_DATE_INTERVAL_SELECTOR.TOOLTIP.WEEK' | translate"
  >
    <span>{{ 'CHART_DATE_INTERVAL_SELECTOR.WEEK' | translate }}</span>
  </button>

  <button
    [ngClass]="{
      'chart-date-interval-selector__item--active': buttonState.activeButton === 'MONTH',
      disabled: buttonState.disabledButtons.MONTH
    }"
    class="chart-date-interval-selector__item"
    (click)="!buttonState.disabledButtons.MONTH ? activeButtonChange('MONTH') : null"
    [matTooltipDisabled]="!buttonState.disabledButtons.MONTH"
    [matTooltip]="'CHART_DATE_INTERVAL_SELECTOR.TOOLTIP.MONTH' | translate"
  >
    <span>{{ 'CHART_DATE_INTERVAL_SELECTOR.MONTH' | translate }}</span>
  </button>
</div>
